module.exports = __webpack_public_path__ + "img/eco.a5332dfe.svg";